/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-20 14:39:10
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2020-05-26 11:31:52
 */

import Vue from "vue";
import Vuex from "vuex";
import sys from "./modules/sys";

Vue.use(Vuex);
export default new Vuex.Store({
  modules: {
    sys
  }
});
